const indexItems = [
  { title: '51黑料最新发布', desc: '实时追踪51黑料网最新内容', icon: 'ri-fire-line', color: 'primary' as const },
  { title: '91黑料入口导航', desc: '91黑料网安全直达入口汇总', icon: 'ri-compass-3-line', color: 'accent' as const },
  { title: '17黑料吃瓜视频', desc: '17黑料网热门视频合集', icon: 'ri-film-line', color: 'primary' as const },
  { title: '718黑料合集', desc: '718黑料全系列归档浏览', icon: 'ri-archive-line', color: 'secondary' as const },
  { title: '91黑料吃瓜速递', desc: '91黑料网最新吃瓜追踪', icon: 'ri-flashlight-line', color: 'accent' as const },
  { title: '黑料51社区', desc: '黑料51热门讨论话题', icon: 'ri-chat-smile-2-line', color: 'primary' as const },
  { title: '17黑料地址', desc: '17黑料网入口地址查询', icon: 'ri-map-pin-line', color: 'secondary' as const },
  { title: '黑料热点榜单', desc: '全品牌实时热度排行', icon: 'ri-bar-chart-line', color: 'accent' as const },
  { title: '数字黑料大全', desc: '全部黑料子品牌入口总览', icon: 'ri-grid-line', color: 'primary' as const },
];

const iconCls: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50',
  accent: 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50',
  secondary: 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">热门索引</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料全品牌内容快速导航入口</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#hero"
              className="group flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/40 transition-all cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg transition-colors flex-shrink-0 ${iconCls[item.color]}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}